/*
 * Copyright (c) 2016 Omnigon Communications, LLC. All rights reserved.
 *
 * This software is the confidential and proprietary information of Omnigon Communications, LLC
 * ("Confidential Information"). You shall not disclose such Confidential Information and shall access and use it only
 * in accordance with the terms of the license agreement you entered into with Omnigon Communications, LLC, its
 * subsidiaries, affiliates or authorized licensee. Unless required by applicable law or agreed to in writing, this
 * Confidential Information is provided on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
 * express or implied. See the license agreement for the specific language governing permissions and limitations.
 */

import BaseControl from 'scripts/base-control';
import can from 'can';

export const QualifyingExemptionsHeader = BaseControl.extend({
    _tabsContentRendered: false,

    init: function() {
        this._super();
        this.awaitRenderTabsContent().then(() => {
            this._tabsContentRendered = true;
            this.tabs = this.$element.find('.s-tabs__item');
            this.findContentTabs();
        });
    },

    findContentTabs() {
        let searchContent = () => {
            this.contentTabs = this.$element
                .closest('.l-qualifying-exemptions')
                .find('.s-tabs__content');
            if (this.contentTabs && this.contentTabs.length) {
                this.selectTab(this.tabs[0]);
            }
        };
        let searchInterval = setInterval(() => {
            if (!this.contentTabs || !this.contentTabs.length) {
                searchContent();
            } else {
                clearInterval(searchInterval);
            }
        }, 300);
        searchContent();
    },

    awaitRenderTabsContent: function() {
        const awaiter = this.can.Deferred();

        if (window.CQ) {
            window.CQ.WCM.addListener('editablesready', () => {
                awaiter.resolve();
            });
        } else {
            awaiter.resolve();
        }

        return awaiter;
    },

    selectTab: function(el) {
        const $el = can.$(el);
        const dataIndex = $el.data('index');

        this.tabs.removeClass('is-selected');
        this.contentTabs.removeClass('is-selected');
        this.tabs.removeAttr('aria-current');

        $el.addClass('is-selected');
        $el.attr('aria-current', 'page');
        const tabContent = this.$element
            .closest('.l-qualifying-exemptions')
            .find(`.s-tabs__content[data-index="${dataIndex}"]`);
        tabContent.addClass('is-selected');
    },

    onTabChange: function(el) {
        if (window.CQ) {
            let tabIndex = el.getAttribute('data-index');
            let selected = el.classList.contains('is-selected');

            window.CQ.WCM.USOPEN.onTabChange(tabIndex, selected);
        }
    },

    '.s-tabs__item click': function($element) {
        if (this._tabsContentRendered && !$element.hasClass('is-selected')) {
            this.selectTab($element);
        }
    },

    '.s-tabs__select change': function($element) {
        if (this._tabsContentRendered) {
            const dataIndex = $element.val();

            this.selectTab(this.tabs.find(`[data-index="${dataIndex}"]`));
        }
    },
});
